import { FC } from 'react'

import ReactMarkdown from 'react-markdown'
import { styled } from 'styled-components'

import CenteredPage from '../Legacy/Page/CenteredPage'
import CodeBlock from './CodeBlock'
import 'github-markdown-css/github-markdown.css'

const StyledDiv = styled.div`
  margin: 8px;
  border-radius: 4px;
  background-color: ${(p) => p.theme.background};
  padding: 8px;

  * {
    border-color: ${(p) => p.theme.border} !important;
    color: ${(p) => p.theme.text};
  }

  h2 {
    border-bottom: none !important;
  }

  /* begin hacks to deal with react-markdown changes in v6 */

  /* stylelint-disable selector-class-pattern */
  .react-syntax-highlighter--codeblock {
    margin: 0 !important;
  }

  pre {
    border: 1px solid ${(p) => p.theme.banner} !important;
    background-color: transparent;
    padding: 0;
  }
`

const components = {
  code: CodeBlock,
}

type MarkdownProps = {
  markdown?: string
  js?: string
  withCenteredPage?: boolean
}

const Markdown: FC<MarkdownProps> = ({
  markdown = '',
  js,
  withCenteredPage = false,
}) => {
  const text = js ? '\n```js\n' + js + '\n```' : markdown

  const Base = (
    <div className='markdown markdown-body'>
      <StyledDiv>
        {_.isString(text) ? (
          <ReactMarkdown
            parserOptions={{ commonmark: true }}
            components={components}
          >
            {text || ''}
          </ReactMarkdown>
        ) : (
          <span>not a string...</span>
        )}
      </StyledDiv>
    </div>
  )

  return withCenteredPage ? <CenteredPage>{Base}</CenteredPage> : Base
}

export default Markdown
